import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResetPasswordForm } from '../components/ResetPasswordForm';

const ResetPasswordPage: React.FC = () => {
    const { t } = useTranslation('auth');

    return (
        <div className="mx-auto">
            <div className="md:grid md:grid-cols-[55%_45%] text-body-text h-svh min-height pt-4 md:pt-0">
                <div className="flex w-full justify-center md:items-center">
                    <div className="w-96 md:p-0 p-8">
                        <h2 className="text-2xl md:text-[28px] font-bold py-2 text-card-title">
                            {t('auth.resetPassword.title', 'Restablecer Contraseña')}
                        </h2>
                        <p className="text-sm leading-relaxed pb-4">
                            {t('auth.resetPassword.description', 'Ingresa tu nueva contraseña')}
                        </p>
                        <ResetPasswordForm />
                    </div>
                </div>

                <div className="h-full w-full items-center justify-center bg-element-bg hidden md:flex">
                    <div className="fixed top-0 right-0 pt-8 px-10">
                        <img
                            src="/imagen/logo_beeping_white.svg"
                            alt="logo"
                            className="w-[180px] h-[26px] object-contain"
                        />
                    </div>
                    <div className="flex flex-col justify-center items-center pt-11 w-96">
                        <div className="">
                            <h1 className="font-bold text-[35px]">
                                {t('auth.login.welcome', '¡Bienvenido de vuelta!')}
                            </h1>
                        </div>

                        <div className="flex justify-center items-center gap-4 w-[384px]">
                            <img src="/imagen/login.png" className="object-contain" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;

